import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <SEO
        title="About — Our story"
        description="How Cake World USA became the wholesale dessert partner of choice for premium hospitality across the United States."
      />
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <div className="eyebrow">About Cake World</div>
          <h1 className="mt-3 font-display text-5xl sm:text-6xl text-brand-ink leading-none">Every occasion needs a sweet touch.</h1>
          <p className="mt-6 text-brand-stone leading-relaxed font-ui text-lg">
            Cake World is a B2B dessert company built for hospitality. We help hotels, restaurants and cafés offer high-end desserts without the complexity of in-house pastry production.
          </p>
          <p className="mt-4 text-brand-stone leading-relaxed font-ui">
            Every product in our collection is designed for consistency at scale — the same recipe, the same finish, the same look every time. Two wholesale formats (3″ Mini Cake and 10″ Whole Cake) cover the way real hospitality operations work: individual plating and shareable presentations.
          </p>

          <div className="dot-divider mt-10" />

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {[
              { k: "Nationwide", v: "B2B distribution across the U.S." },
              { k: "2 formats", v: "3″ Mini · 10″ Whole" },
              { k: "1 business day", v: "Quote turnaround" },
            ].map((s) => (
              <div key={s.k} className="rounded-2xl bg-white border border-brand-line p-5 shadow-soft">
                <div className="font-display text-2xl text-brand-red">{s.k}</div>
                <div className="text-xs text-brand-stone mt-1 font-ui">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link to="/request-quote" data-testid="about-request-quote" className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-brand-red text-white text-sm font-ui font-semibold hover:bg-brand-redDark active:scale-95 transition">
              Request a wholesale quote <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-3xl overflow-hidden shadow-soft-lg aspect-[4/5] bg-brand-pinkLight">
            <img src="https://customer-assets-7cd3h4nn.emergentagent.net/job_bakery-b2b/artifacts/okttnm4i_181.jpg" alt="New York Cheesecake" className="w-full h-full object-contain p-8" />
          </div>
        </div>
      </div>
    </div>
  );
}
